import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import "../style.css"
import styles from './MileageSaarathi.module.css';
import moment from 'moment';
import ChartLoader from './Loader_MS_bus';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";


const FaultIncidentTable = forwardRef(({ filterdata, setExpertInsightLoading }, ref) => {
    const [issueType, setIssueType] = useState('Warning');
    const [tableData, setTableData] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 4;
    const totalPages = Math.ceil(tableData.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const { isLoading, error, sendReq: fetchData } = useHttp();


    useEffect(() => {
        setExpertInsightLoading(true)
        fetchData(
            {
                url: API_URL_MAIN + `mileage_sarathi_ace/${issueType == "Warning" ? "faults_incidents_warning" : "faults_incidents_critical"}`,
                body: { filterdata }
            },
            (data) => {

                let resData = data?.groupby?.buckets || []
                setTableData(resData)
                setCurrentPage(1)
                setExpertInsightLoading(false)
            }
        );
    }, [filterdata, issueType])


    const currentItems = tableData.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prev => prev + 1);
        }
    };


    function formatLabel(input) {
        return input.replace(/_(1\.0|2\.0|3\.0)$/, '');
    }

    function checkStatus(inputArray) {
        const targets = [
            " A_Fault_Rank_1.0",
            "A_Fault_Rank_2.0",
            "A_Fault_Rank_3.0",
            "A_Derate_Flag_1.0",
            "B_Fault_Rank_1.0",
            "B_Fault_Rank_2.0",
            "B_Fault_Rank_3.0",
            "B_Derate_Flag",
            "C_Fault_Rank_1.0",
            "C_Fault_Rank_2.0",
            "C_Fault_Rank_3.0",
            "C_Derate_Flag",
            "D_Fault_Rank_1.0",
            "D_Fault_Rank_2.0",
            "D_Fault_Rank_3.0",
            "D_Derate_Flag_1.0",
            "BMS_Derate_1.0",
            "MCU_Derate_1.0",
        ];

        return inputArray?.some(item => targets.includes(item));
    }

    function checkActionString(input) {
        if (
            input.includes("Coolant_low_1")
        ) {
            return "Pls check Traction coolant string";
        } else {
            return "Visit the service center as soon as possible.";
        }
    }

    function toggleVisibility(index) {
        const section = document.getElementById(`section-${index}`);
        if (section) {
            section.classList.toggle("d-none");
        }
    }

    const openGoogleUrl = (lat, long) => {

        const newURL = `https://www.google.com/maps/search/${lat},${long}?sa=X&ved=1t:242&ictx=111`
        window.open(newURL, "_blank");
    }
    useImperativeHandle(ref, () => ({
        downloadData: () => {
            const fileType =
                "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const excelFileName = "Fault/Incidents Report";

            const flatData = tableData.map((item, index) => ({
                'Sr. No': index + 1,
                'VIN': item?.key.vehicleId,
                'Register Number': item?.key.vehicle_registration_number,
                "Count": item?.L4_fault_distinct?.buckets?.length,
                "Incidents": item?.L4_fault_distinct?.buckets?.map((issue, i) => formatLabel(issue?.key)).join(","),
                "Timestamp": item?.L4_fault_distinct?.buckets?.map((issue, i) => moment(issue?.earliest_event?.hits?.hits[0]?._source?.eventdatetime).format("hh.mm A, DD/MMM-YY").toLowerCase()).join(","),
                "Status": (issueType === 'Warning' && !checkStatus(item?.L4_fault_distinct?.buckets?.map(obj => obj.key))) ? "Warning" : "Fault",
                'Suggested Actions': item?.L4_fault_distinct.buckets?.map((issue, i) => issueType == "Critical" ? 'Immediately need to contact to service center' : checkActionString(issue?.key) || "--").join(",")
            }));

            const ws = XLSX.utils.json_to_sheet(flatData);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, excelFileName + fileExtension);

        }
    }))

    return (
        <>
            <div className="row mb-3">
                <div className="col-md-12">
                    <div className="d-flex justify-content-between">
                        <div className="small text-muted">Below data shows on a real-time basis</div>
                        <div className="d-flex">
                            <button
                                className="btn btn-sm me-2"
                                style={{
                                    backgroundColor: issueType === 'Critical' ? '#3d8b9b' : 'transparent',
                                    color: issueType === 'Critical' ? '#fff' : '#3d8b9b',
                                    borderColor: '#3d8b9b'
                                }}
                                onClick={() => setIssueType('Critical')}
                            >
                                Critical
                            </button>
                            <button
                                className="btn btn-sm"
                                style={{
                                    backgroundColor: issueType === 'Warning' ? '#3d8b9b' : 'transparent',
                                    color: issueType === 'Warning' ? '#fff' : '#3d8b9b',
                                    borderColor: '#3d8b9b'
                                }}
                                onClick={() => setIssueType('Warning')}
                            >
                                Warning
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`table-responsive p-0 ${styles.vehicle_analysis}`} style={{ overflowY: "scroll", height: "350px", position: "relative" }}>
                <table className={`table table-hover table-bordered m-0 ${styles.vehicle_analysis_table}`}>
                    <thead>
                        <tr className={styles.vehicle_analysis_tablerow} style={{ backgroundColor: '#3d8b9b', color: '#fff', position: 'sticky', top: 0 }}>
                            <th className="fw-bold">Sr. No.</th>
                            <th className="fw-bold">Vehicle Detail</th>
                            <th className="fw-bold">Incidents</th>
                            <th className="fw-bold">{issueType} Issues</th>
                            <th className={`fw-bold ${styles.suggestedActionWidth}`}>Suggested Actions</th>
                            <th className="fw-bold">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? <tr>
                            <td colSpan={6} style={{ padding: 0 }}>
                                <ChartLoader />
                            </td>
                        </tr> : currentItems.length ?
                            currentItems?.map((incident, index) => (
                                <tr
                                    key={index}
                                    className={incident.status === 'Warning' ? 'table-secondary' : ''}
                                    style={{ backgroundColor: '#fff' }}
                                >
                                    <td className="align-middle">{index + 1}</td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className={`rounded-circle text-white d-flex align-items-center justify-content-center me-2 ${styles.vehicle_icon}`}>
                                                <i className="fas fa-truck"></i>
                                            </div>
                                            <div>
                                                <p className="m-0 fw-bold">{incident.key?.vehicle_registration_number || "--"}</p>
                                                <p className="m-0 small">{incident?.key?.vehicleId || "--"}</p>
                                                <span className="m-0 small">{incident?.key?.PL}</span> <span className="m-0 small">|</span> <span className="m-0 small">{incident?.key?.LOB}</span>
                                                <div
                                                    className={`d-block mt-1 pt-1 badge ${incident.status === 'Warning' ? 'bg-secondary' : ''}`}

                                                    style={{ backgroundColor: (issueType === 'Warning' && !checkStatus(incident?.L4_fault_distinct?.buckets?.map(obj => obj.key))) ? "gray" : "#3d8b9b" }}
                                                >
                                                    {issueType === 'Warning' ? "Warning" : "Fault"}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="align-middle">{incident?.L4_fault_distinct?.buckets?.length || '--'}</td>
                                    <td>
                                        {incident?.L4_fault_distinct?.buckets?.length ? (
                                            <div>
                                                <p className="m-0">{incident[issueType.toLowerCase() + 'Issue']}</p>
                                                {incident?.L4_fault_distinct?.buckets?.map((issue, i) => (
                                                    <div key={i} className="mt-2">
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-exclamation-triangle text-warning me-1"></i>
                                                            <p className="m-0 fw-bold">{formatLabel(issue?.key)}</p>
                                                        </div>
                                                        <p className="m-0 small">{moment(issue?.earliest_event?.hits?.hits[0]?._source?.eventdatetime).format("hh.mm A, DD/MMM-YY").toLowerCase() || "--"}</p>
                                                        <p className="m-0 small">{issue?.description}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="m-0">-</p>
                                        )}
                                    </td>
                                    <td>
                                        {incident?.L4_fault_distinct?.buckets?.length ? (
                                            <div >
                                                {incident?.L4_fault_distinct?.buckets?.map((issue, i) => (
                                                    <div key={i} className="mt-2">
                                                        <div className="">
                                                            <p className="m-0">
                                                                {
                                                                    issueType == "Critical" ? <p className="m-0 medium">Immediately need to contact to service center</p>
                                                                        : <div>
                                                                            {checkActionString(issue?.key) || "--"}
                                                                        </div>
                                                                }
                                                            </p>
                                                        </div>
                                                        <p className="mb-4 mt-1 small "></p>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="m-0">-</p>
                                        )}



                                    </td>
                                    <td className="align-middle">
                                        <div>
                                            {incident.actionTime && (
                                                <span className="small d-block mb-1">{incident.actionTime}</span>
                                            )}
                                            <div
                                                onClick={() => toggleVisibility(index)}
                                                className={styles.incidents_tab_details}
                                            >
                                                <i className="fas fa-eye me-1" ></i>View Details
                                            </div>
                                            <div id={`section-${index}`} className={`cursor_pointer d-none ${styles.incidents_tab_locations}`} onClick={() => incident?.L4_fault_distinct?.buckets?.length ? openGoogleUrl(incident?.L4_fault_distinct?.buckets[0]?.earliest_event?.hits?.hits[0]?._source?.gpsLatitude, incident?.L4_fault_distinct?.buckets[0]?.earliest_event?.hits?.hits[0]?._source?.gpsLongitude) : null}>
                                                <i className="fas fa-map-marker-alt me-1"></i>View Location
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            )) : <tr> <td colSpan={6} className='text-center table-cell' > No Data found</td></tr>}
                    </tbody>
                </table>
            </div>

            {currentItems?.length ?
                <>
                    <div className="small text-muted mt-2">
                        Showing {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, tableData.length)} of {tableData.length} entries
                    </div>
                    <div className="d-flex justify-content-center mt-3 align-items-center flex-nowrap">

                        <button
                            className={`${currentPage === 1 ? "btn btn-link" : styles.ms_button}`}
                            onClick={handlePrevPage}
                            disabled={currentPage === 1}
                        >
                            <i className={`fas fa-chevron-left ms_button`}></i> Prev
                        </button>

                        {/* Show first page and ellipsis if needed */}
                        {currentPage > 3 && (
                            <>
                                <button
                                    className={`mx-1 ${currentPage === 1 ? styles.page_number_icons_prev : styles.page_number_icons_next}`}
                                    onClick={() => handlePageChange(1)}
                                >
                                    1
                                </button>
                                {currentPage !== 4 && <span className="mx-1">...</span>}
                            </>
                        )}

                        {/* Middle page buttons */}
                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(page =>
                                page === currentPage ||
                                page === currentPage - 1 ||
                                page === currentPage + 1
                            )
                            .map(page => (
                                <button
                                    key={page}
                                    className={`mx-1 btn btn-sm ${currentPage === page ? styles.page_number_icons_prev : styles.page_number_icons_next}`}
                                    onClick={() => handlePageChange(page)}
                                >
                                    {page}
                                </button>
                            ))}

                        {/* Show last page and ellipsis if needed */}
                        {currentPage < totalPages - 2 && (
                            <>
                                {currentPage !== totalPages - 3 && <span className="mx-1">...</span>}
                                <button

                                    className={`mx-1 btn btn-sm   ${currentPage === totalPages ? styles.page_number_icons_prev : styles.page_number_icons_next}`}
                                    onClick={() => handlePageChange(totalPages)}
                                >
                                    {totalPages}
                                </button>
                            </>
                        )}

                        <button
                            className={` ${currentPage === totalPages ? "btn btn-link" : styles.ms_button}`}
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages}
                        >
                            Next <i className="fas fa-chevron-right"></i>
                        </button>
                    </div>
                </> : <></>
            }
        </>
    )
})

export default FaultIncidentTable
